import { FormControlLabel, FormLabel, Radio } from "@mui/material";
import { useCallback, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState} from "recoil";
import { FormRadioGroup } from "../../../../../components/fields";
import { BookingScope, ReactQueryKey, RentalType } from "../../../../../types";
import { isLeisureCode, rangeDateValidity, ratePlanOfferIDState, stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";
import { IRangeDate } from "../../../../../api/services";
import { useQueryClient } from "@tanstack/react-query";
import { GlobalContext } from "../../../../../../../util/state/GlobalContextProvider";
import { hasScope } from "../../../../../utils";

const FormRentalType = () => {

    const { t } = useTranslation('booking');

    const queryClient = useQueryClient();

    const { globalData } = useContext(GlobalContext);
    const step = useRecoilValue(stepState);
    const setRangeDate = useSetRecoilState<IRangeDate | undefined>(rangeDateValidity);
    const setLeisureCode = useSetRecoilState(isLeisureCode);
    const setRatePlanOfferID = useSetRecoilState(ratePlanOfferIDState);

    const formContext = useFormContext<IFormValues>();

    /**
     * Change Radio
     */
    const handleChange = useCallback(() => {
        formContext.resetField('bookingOwner');
        formContext.resetField('invoice');
        formContext.resetField('basicDetails.pickupLocation');
        formContext.resetField('basicDetails.dropoffLocation');
        formContext.resetField('basicDetails.customerCode');
        formContext.resetField('basicDetails.carGroup');
        formContext.resetField('basicDetails.mileageIncluded');
        formContext.resetField('basicDetails.cig');
        formContext.resetField('basicDetails.dossierNumber');
        formContext.resetField('extraServices');
        setLeisureCode(false);

        queryClient.resetQueries([ReactQueryKey.Product, {
            segment: formContext.getValues('basicDetails.rentalType'),
            tenant: formContext.getValues('basicDetails.tenants') as string,
            dealer: formContext.getValues('basicDetails.dealers') as string
        }]);

        setRangeDate({startDate: null, endDate: null});
        setRatePlanOfferID(undefined);

    }, []);

    return (
        <>
            <FormLabel>{t('label.rentalType')}</FormLabel>
            <FormRadioGroup<IFormValues>
                name="basicDetails.rentalType"
                onChange={handleChange}
            >
                <FormControlLabel
                    value={RentalType.RETAIL}
                    label={t('label.public')}
                    control={<Radio disabled={step === InsertBookingStep.CUSTOMER_DETAILS} />}
                />
                {hasScope(globalData, BookingScope.InsertBookingB2B) && (
                    <FormControlLabel
                        value={RentalType.CORPORATE}
                        label={t('label.affiliated')}
                        control={<Radio disabled={step === InsertBookingStep.CUSTOMER_DETAILS} />}
                    />
                )}
            </FormRadioGroup >
        </>
    );
}

export default FormRentalType;
